// Client-side PAN & GSTIN validation (format + checksum). Mirrors backend gst_utils.
const PAN_RE = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
const GSTIN_RE = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
const CODE = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const STATE_CODES = new Set([
  "01","02","03","04","05","06","07","08","09","10","11","12","13","14","15","16","17","18","19",
  "20","21","22","23","24","26","27","29","30","31","32","33","34","35","36","37","38",
]);

export const normalize = (v) => (v || "").trim().toUpperCase().replace(/\s/g, "");

export function validatePan(pan) {
  const p = normalize(pan);
  if (!p) return "PAN is required.";
  if (!PAN_RE.test(p)) return "Invalid PAN. Expected format AAAAA9999A (e.g. ABCDE1234F).";
  return "";
}

function gstinChecksumChar(g14) {
  let factor = 2, total = 0;
  for (let i = g14.length - 1; i >= 0; i--) {
    const cp = CODE.indexOf(g14[i]);
    const prod = cp * factor;
    total += Math.floor(prod / 36) + (prod % 36);
    factor = factor === 2 ? 1 : 2;
  }
  return CODE[(36 - (total % 36)) % 36];
}

export function validateGstin(gstin) {
  const g = normalize(gstin);
  if (!g) return "GSTIN is required.";
  if (g.length !== 15 || !GSTIN_RE.test(g)) return "Invalid GSTIN. Expected 15 characters (e.g. 27ABCDE1234F1Z5).";
  if (!STATE_CODES.has(g.slice(0, 2))) return `Invalid GSTIN state code '${g.slice(0, 2)}'.`;
  if (gstinChecksumChar(g.slice(0, 14)) !== g[14]) return "Invalid GSTIN checksum — please re-check the number.";
  return "";
}

export function crossCheckPanGstin(pan, gstin) {
  const p = normalize(pan);
  const embedded = normalize(gstin).slice(2, 12);
  if (p && embedded && p !== embedded) return `PAN ${p} does not match the PAN in the GSTIN (${embedded}).`;
  return "";
}
